import { timeHelper } from "../../helpers";
import React from "react";
import moment from "moment";

export interface TimePresenterProps {
    children: string | number;
    variant?: "date" | "time" | "datetime" | "duration";
    parseFormat?: string;
    outputFormat?: string;
    fromNow?: boolean;
    parseTimezone?: string | number | "utc";
    outputTimezone?: string | number | "user";
}

export function TimePresenter({
    children,
    outputTimezone = "user",
    parseTimezone = "utc",
    variant = "date",
    parseFormat = "X",
    outputFormat = "MMMM D, YYYY",
    fromNow = false
}: TimePresenterProps) {
    const timeStr = !fromNow
        ? timeHelper
              .convertUtcToUserTime(children.toString(), parseFormat)
              .format(outputFormat)
        : moment(children.toString(), parseFormat).fromNow(true);
    return (
        <span
            title={timeHelper
                .convertUtcToUserTime(children.toString(), parseFormat)
                .format("MMMM D, YYYY hh:mm:ss A")}
        >
            {timeStr}
        </span>
    );
}

export default TimePresenter;
